import React from 'react'

import Box from '@material-ui/core/Box'

export default () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight={461}
  >
    <span>Loading...</span>
  </Box>
)
